var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColor(_vm.params)}},[_c('span',[_vm._v(_vm._s(_vm.organizationTypeString(_vm.params)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }